import React from "react"
import Label from "../../Components/Forms/Label"
import Instructions from "../../Components/Forms/Instructions"
import { useFormikContext, getIn } from "formik"
import { cn } from "../../lib/utils"

const FormikField = ({
  name,
  title,
  instructions,
  children,
  primary = false,
  width,
  containerClassName,
  required = false,
}) => {
  const { errors, touched, submitCount } = useFormikContext()
  const error = getIn(errors, name)
  const isTouched = getIn(touched, name)

  // Show error only after the field has been blurred, or after a submit attempt
  const showError = error && (isTouched || submitCount > 0)

  // Clone children with error prop only if it's a single valid React element
  const childrenWithError = React.isValidElement(children)
    ? React.cloneElement(children, {
        error: showError ? error : undefined,
      })
    : children

  return (
    <div className={cn("mb-4", containerClassName)}>
      <Label primary={primary} name={name}>
        {title}{required && title && <span className="text-red-500 ml-1">*</span>}
      </Label>
      {instructions && instructions.length > 0 && (
        <Instructions>
          {instructions.map((instruction, index) => {
            return <p key={index} className="mt-2">{instruction}</p>
          })}
        </Instructions>
      )}
      <div className={width}>
        {childrenWithError}
        {showError && (
          <div className="mb-4 w-full rounded-lg text-red-500 p-4 text-sm font-bold text-center">{error}</div>
        )}
      </div>
    </div>
  )
}

export default FormikField
